<template>
  <v-text-field
    ref="field"
    v-model="inner_value"
    lang="en"
    type="number"
    outlined
    :prepend-icon="prependIcon"
    v-bind="_attrs"
    @keydown="onKeyInput"
    v-on="_listeners"
    @click:prepend="onPrependIconClick"
  >
    <slot
      v-for="(_, name) in $slots"
      :slot="name"
      :name="name"
    />
    <template
      v-for="(_, name) in $scopedSlots"
      :slot="name"
      slot-scope="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </v-text-field>
</template>
<script>
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export default {
  name: 'AgrialInputNumber',
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    disabledScroll: {
      type: Boolean,
      default: false
    },
    prependIcon: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      inner_value: null,
      preventNextNullValue: false
    }
  },
  computed: {
    _attrs () {
      return this.$attrs
    },
    _listeners () {
      const listeners = Object.assign({}, this.$listeners)
      delete listeners.input
      return listeners
    }
  },
  watch: {
    value () {

      // eslint-disable-next-line eqeqeq
      if (this.parseNumber(this.inner_value) != this.parseNumber(this.value)) {
        // if value realy update
        this.setInnerValue(this.value)
      }
    },
    inner_value (oldValue, newvalue) {
      // clean value
      this.setInnerValue(this.inner_value)
      // eslint-disable-next-line eqeqeq
      if (this.parseNumber(oldValue) != this.parseNumber(newvalue)) {
        // if value realy update
        this.updateValue()
      }
    }
  },
  created () {
    this.setInnerValue(this.value)
  },
  mounted () {
    if (this.disabledScroll) {
      this.disableScrollBehavior()
    }
  },
  methods: {
    numberToString (value) {
      // tostring
      const str = value === null || value === undefined ? '' : (typeof value === 'number' ? value.toString() : value)
      // clean string
      return str.replace(/[^0-9,.+-]/g, '').replace(',', '.')
    },
    parseNumber (str) {
      if (str === null || str === undefined || str === '') {
        return null
      }
      const val = parseFloat(this.numberToString(str))
      return isNaN(val) ? null : val
    },
    setInnerValue (value) {
      // to string
      const str = this.numberToString(value)
      // is valid
      const _value = this.parseNumber(str)

      if (_value !== null) {
        this.inner_value = str
      } else {
        this.inner_value = ''
      }
      if (this.inner_value !== value) {
        setTimeout(() => { this.$forceUpdate() }, 200)
      }
    },
    updateValue () {
      const value = this.parseNumber(this.inner_value)
      if (value === null && this.preventNextNullValue) {
        this.preventNextNullValue = false
        return
      }
      this.$emit('input', value)
    },
    onKeyInput (event) {
      if (event.key === 'e') {
        event.preventDefault()
        event.stopPropagation()
      }
      if (event.key === '.') {
        // trick for prevent "[0-9]+\." inputs to return null (browser limitation)
        this.preventNextNullValue = true
      } else {
        this.preventNextNullValue = false
      }
    },
    disableScrollBehavior () {
      const field = this.$refs.field
      field.$el.addEventListener('wheel', this.disableScroll)
    },
    disableScroll (e) {
      // Désactive le scrol si l'input est focus
      if (document.activeElement === e.target) {
        e.preventDefault()
      }
    },
    onPrependIconClick () {
      this.$emit('prependIconClick')
    }
  }
}
</script>
